import { Routes } from "~/routes";

// // // //

export function getEmailVerifyRedirectUrl(props: { email: string }) {
    const { email } = props;
    return `${Routes.authVerify}?email=${encodeURIComponent(email)}`;
}
